// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_26hLx","static-links":"_1SUXQ"};